var exports = {
  "Lg": "GuildSidebarSkeleton.module__navigation___SWtSMk",
  "X9": "GuildSidebarSkeleton.module__detachedBanner___SWtSMk",
  "GG": "GuildSidebarSkeleton.module__topSpacer___SWtSMk",
  "dl": "GuildSidebarSkeleton.module__membersSection___SWtSMk",
  "ne": "GuildSidebarSkeleton.module__membersSeparator___SWtSMk",
  "vd": "GuildSidebarSkeleton.module__bottomDropZone___SWtSMk",
  "TN": "GuildSidebarSkeleton.module__groups___SWtSMk",
  "Os": "GuildSidebarSkeleton.module__group___SWtSMk",
  "nM": "GuildSidebarSkeleton.module__row___SWtSMk",
  "bQ": "GuildSidebarSkeleton.module__rowCategory___SWtSMk",
  "me": "GuildSidebarSkeleton.module__categoryCaret___SWtSMk",
  "et": "GuildSidebarSkeleton.module__rowChannel___SWtSMk",
  "Ec": "GuildSidebarSkeleton.module__rowMembers___SWtSMk",
  "p": "GuildSidebarSkeleton.module__channelIcon___SWtSMk",
  "US": "GuildSidebarSkeleton.module__bottomSpacer___SWtSMk",
};

module.exports = exports;
